import { useState, useEffect, useCallback } from 'react';
import communityService from '../../../api/communityService';

/**
 * Custom Hook: useCategories
 * Manages post categories state
 * Fetches and caches categories for post creation and filtering
 */
const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Fetch all categories
   */
  const fetchCategories = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await communityService.getAllCategories();

      if (response?.data?.data?.categories) {
        setCategories(response.data.data.categories || []);
      }
    } catch (err) {
      console.error('Error fetching categories:', err);
      setError(err?.response?.data?.message || 'Failed to load categories');
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch categories on mount
  useEffect(() => {
    fetchCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency - only run once on mount

  return {
    categories,
    loading,
    error,
    refresh: fetchCategories,
  };
};

export default useCategories;
